import { Component, HostListener } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { CustomActivityDialogActionService } from './custom-activity-dialog';
import { ProfileStateFormService, ProfileStateService } from '../../common';

@Component({
  selector: 'custom-activity-action-button',
  templateUrl: './custom-activity-action-button.component.html',
  styleUrls: ['./custom-activity-action-button.component.scss'],
  viewProviders: [ CustomActivityDialogActionService ]
})
export class CustomActivityActionButtonComponent {

  constructor(
    private stateService: ProfileStateService,
    private formStateService: ProfileStateFormService,
    private customActivityDialog: CustomActivityDialogActionService
  ) { }

  @HostListener('click')
  hostClick(): void {
    this.formStateService.resetActivityDialogForm();
    this.stateService.resetScroll$.next(true);
    const ref = this.customActivityDialog.open(this.formStateService.activityDialogForm);
    (ref as MatDialogRef<any>).afterClosed().subscribe(() => {
      this.stateService.resetScroll$.next(false);
    });
  }

}
